(() => {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: window.molloCurrency || 'EUR', maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    } catch (error) { return `${(Number(cents || 0) / 100).toFixed(2)} ${window.molloCurrency || 'EUR'}`; }
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const toast = (message) => {
    let element = document.querySelector('[data-toast]');
    if (!element) {
      element = document.createElement('div');
      element.className = 'toast';
      element.dataset.toast = '';
      document.body.appendChild(element);
    }
    element.textContent = message;
    element.classList.add('show');
    window.clearTimeout(element.toastTimer);
    element.toastTimer = window.setTimeout(() => element.classList.remove('show'), 2600);
  };

  const header = document.querySelector('[data-site-header]');
  const onScroll = () => header && header.classList.toggle('scrolled', window.scrollY > 12);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const menuButton = document.querySelector('[data-menu-button]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  menuButton?.addEventListener('click', () => {
    const open = mobileMenu.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', String(open));
  });
  mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => mobileMenu.classList.remove('open')));

  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.08 });
    reveals.forEach((element) => observer.observe(element));
  } else { reveals.forEach((element) => element.classList.add('visible')); }

  document.querySelectorAll('[data-carousel]').forEach((button) => button.addEventListener('click', () => {
    const rail = document.getElementById(button.dataset.carousel);
    if (!rail) return;
    rail.scrollBy({ left: Number(button.dataset.direction || 1) * Math.min(rail.clientWidth * 0.82, 520), behavior: 'smooth' });
  }));

  const clock = document.querySelector('[data-live-clock]');
  if (clock) {
    ['hour', 'minute', 'second'].forEach((name) => {
      const hand = document.createElement('span'); hand.className = `hand ${name}`; clock.appendChild(hand);
    });
    const pin = document.createElement('span'); pin.className = 'pin'; clock.appendChild(pin);
    const updateClock = () => {
      const now = new Date();
      const h = clock.querySelector('.hour'); const m = clock.querySelector('.minute'); const s = clock.querySelector('.second');
      h.style.transform = `translateX(-50%) rotate(${(now.getHours() % 12) * 30 + now.getMinutes() / 2}deg)`;
      m.style.transform = `translateX(-50%) rotate(${now.getMinutes() * 6}deg)`;
      s.style.transform = `translateX(-50%) rotate(${now.getSeconds() * 6}deg)`;
    };
    updateClock(); window.setInterval(updateClock, 1000);
    const zone = document.querySelector('[data-timezone]');
    if (zone) zone.textContent = Intl.DateTimeFormat().resolvedOptions().timeZone.replaceAll('_', ' ');
  }

  document.querySelectorAll('[data-gallery-src]').forEach((thumb) => thumb.addEventListener('click', () => {
    const main = document.getElementById('ProductMainImage');
    if (!main) return;
    main.src = thumb.dataset.gallerySrc;
    document.querySelectorAll('[data-gallery-src]').forEach((item) => item.classList.remove('active'));
    thumb.classList.add('active');
  }));

  const openModal = (modal) => {
    if (!modal) return;
    modal.hidden = false;
    requestAnimationFrame(() => modal.classList.add('open'));
    document.body.classList.add('locked');
  };
  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('open');
    window.setTimeout(() => { modal.hidden = true; }, 320);
    document.body.classList.remove('locked');
  };
  document.querySelectorAll('[data-modal-open]').forEach((button) => button.addEventListener('click', () => openModal(document.getElementById(button.dataset.modalOpen))));
  document.querySelectorAll('[data-modal-close]').forEach((button) => button.addEventListener('click', () => closeModal(button.closest('.modal'))));
  document.querySelectorAll('.modal').forEach((modal) => modal.addEventListener('click', (event) => { if (event.target === modal) closeModal(modal); }));

  document.querySelectorAll('[data-wrist-upload]').forEach((input) => input.addEventListener('change', () => {
    const file = input.files && input.files[0];
    if (!file || !file.type.startsWith('image/')) return;
    const preview = input.closest('.modal-panel').querySelector('[data-wrist-preview]');
    const image = preview.querySelector('[data-wrist-image]');
    const reader = new FileReader();
    reader.onload = () => { image.src = reader.result; preview.hidden = false; };
    reader.readAsDataURL(file);
  }));

  const advisorCopy = {
    steel: 'A brushed-steel bracelet will feel the most precise and versatile. Pair it with a black, silver or deep blue dial.',
    light: 'Choose an ivory or silver dial with a taupe leather strap for a softer, understated expression.',
    wine: 'A dark dial or oxblood strap will add character while keeping the overall silhouette refined.'
  };
  document.querySelectorAll('[data-advisor-answer]').forEach((button) => button.addEventListener('click', () => {
    const result = button.closest('.modal-panel').querySelector('[data-advisor-result]');
    result.textContent = advisorCopy[button.dataset.advisorAnswer] || '';
  }));

  document.querySelectorAll('[data-filter]').forEach((button) => button.addEventListener('click', () => {
    const filter = button.dataset.filter;
    const cards = [...document.querySelectorAll('[data-collection-grid] .product-card')];
    document.querySelectorAll('[data-filter]').forEach((item) => item.classList.toggle('active', item === button));
    let count = 0;
    cards.forEach((card) => {
      const visible = filter === 'all' || (card.dataset.tags || '').includes(filter);
      card.hidden = !visible; if (visible) count += 1;
    });
    const counter = document.querySelector('[data-collection-count]');
    if (counter) counter.textContent = `${count} ${count === 1 ? 'piece' : 'pieces'}`;
  }));
  document.querySelectorAll('[data-sort-select]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    const variantData = productRoot.querySelector('[data-product-variants]');
    const select = productRoot.querySelector('[data-variant-select]');
    if (!variantData || !select) return;
    let variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (error) { return; }
    const groups = [...productRoot.querySelectorAll('[data-option-position]')];
    const updateVariant = () => {
      const choices = groups.map((group) => group.querySelector('[data-option-value].active')?.dataset.optionValue || '');
      const variant = variants.find((item) => item.options.every((option, index) => option === choices[index]));
      if (!variant) return;
      select.value = String(variant.id);
      const price = productRoot.querySelector('[data-product-price]');
      const add = productRoot.querySelector('[data-add-to-cart]');
      const label = productRoot.querySelector('[data-add-label]');
      const stock = productRoot.querySelector('[data-stock-note]');
      if (price) price.textContent = money(variant.price);
      if (add) add.disabled = !variant.available;
      if (label) label.textContent = variant.available ? `Add to bag — ${money(variant.price)}` : 'Sold out';
      if (stock) stock.textContent = variant.available ? 'In stock · Ready to order' : 'Currently unavailable';
      if (variant.featured_image && variant.featured_image.src) {
        const main = document.getElementById('ProductMainImage'); if (main) main.src = variant.featured_image.src;
      }
      productRoot.dispatchEvent(new CustomEvent('mollo:variant-change', { detail: { variant } }));
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    };
    groups.forEach((group) => group.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => {
      group.querySelectorAll('[data-option-value]').forEach((item) => item.classList.toggle('active', item === button));
      const label = group.querySelector('[data-option-label]'); if (label) label.textContent = button.dataset.optionValue;
      updateVariant();
    })));
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((counter) => { counter.textContent = cart.item_count; });
    const container = drawer?.querySelector('[data-cart-items]');
    const footer = drawer?.querySelector('[data-cart-footer]');
    if (!container || !footer) return;
    if (!cart.item_count) {
      container.innerHTML = `<div class="empty-cart"><p>Your bag is empty.</p><a class="button button-dark" href="${root}collections/all">Explore watches</a></div>`;
      footer.hidden = true; return;
    }
    container.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : '';
      return `<div class="drawer-item">${image}<div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>${variant}<span>Qty ${item.quantity} · ${money(item.final_line_price)}</span></div></div>`;
    }).join('');
    footer.hidden = false;
    const total = footer.querySelector('[data-cart-total]'); if (total) total.textContent = money(cart.total_price);
  };
  const refreshCart = () => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json()).then(renderCart);
  const openCart = () => {
    if (!drawer || !backdrop) return;
    refreshCart().catch(() => {});
    backdrop.hidden = false;
    requestAnimationFrame(() => { drawer.classList.add('open'); backdrop.classList.add('open'); });
    drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('locked');
  };
  const closeCart = () => {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('open'); backdrop.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => { backdrop.hidden = true; }, 380); document.body.classList.remove('locked');
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  backdrop?.addEventListener('click', closeCart);

  const addForm = async (form) => {
    const submit = form.querySelector('[data-add-to-cart]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add this item');
      await refreshCart(); openCart(); toast('Added to your bag');
    } catch (error) { toast(error.message || 'Please try again'); }
    finally { if (submit) submit.disabled = false; }
  };
  document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', (event) => { event.preventDefault(); addForm(form); }));
  document.querySelectorAll('[data-quick-add]').forEach((button) => button.addEventListener('click', async () => {
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(button.dataset.quickAdd), quantity: 1 }] }) });
      if (!response.ok) throw new Error('Unable to add this item');
      await refreshCart(); openCart(); toast('Added to your bag');
    } catch (error) { toast(error.message || 'Please try again'); }
    finally { button.disabled = false; }
  }));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.modal.open').forEach(closeModal); closeCart();
  });
})();
